import React, { useState } from 'react';
import BlazeInputDropdown, { BlazeDropdownItem } from 'components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';
import { createAllCraneLocations } from 'utils/locationUtil';
import { useTranslation } from 'react-i18next';

type LocationDropdownProps = {
  locations: any[];
  selectLocation: (location: any) => void; // TODO check if we need to send id or location name
};

const AnalyticsLocationDropdown = (props: LocationDropdownProps) => {
  const locationPickerId = 'analytics-location-picker';
  const [selectedLocation, setSelectedLocation] = useState<BlazeDropdownItem | null>(null);
  const { t } = useTranslation('analytics');

  const selectItemHandler = (item: BlazeDropdownItem) => {
    setSelectedLocation(item);
    //Id with 0 = "All Locations" item
    if (item.id === 0) {
      props.selectLocation(null);
    } else {
      props.selectLocation(item.metaData);
    }
  };

  return (
    <div className="mt-3">
      <label htmlFor={locationPickerId}>{t('analyticsDropdown.locations.title')}</label>
      <BlazeInputDropdown
        id={locationPickerId}
        showGroups={true}
        minDropdownMenuWidth={327}
        maxDropdownHeight={250}
        items={createAllCraneLocations(props.locations)}
        selected={selectedLocation}
        onClick={selectItemHandler}
        isSearchable={true}
        searchPlaceholder={t('analyticsDropdown.locations.placeholder')}
        isDefaultOptionSelectable={true}
        defaultOption={{ id: 0, name: t('analyticsDropdown.locations.defaultOption') }}
      />
    </div>
  );
};

export default AnalyticsLocationDropdown;
